import { gql } from "@apollo/client";

export const USER_PREFILL_DATA = gql`
  query userPrefillData {
    userPrefillData {
      firstName
      lastName
      email
      phoneNumber
      dateOfBirth
      address {
        unitNo
        street
        city
        state
        country
        postalCode
      }
      ssn
    }
  }
`;
